import { Box, Button, Flex, Text } from '@chakra-ui/react';
import CreateGoalTabs from '../components/CreateGoalTabs';
import { useNavigate } from 'react-router';
import { useState } from 'react';
import { GoalState } from '../helpers/goals.types';

export const CreateGoals = () => {
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const [goalState, setGoalState] = useState<GoalState | undefined>(undefined);

  return (
    <Flex direction={'column'} w={'100%'} gap={1}>
      <Button
        onClick={() => navigate(-1)}
        size="sm"
        variant="link"
        w={'fit-content'}
      >
        Back
      </Button>
      <Text fontSize={'xl'} color={'text.gray.300'} fontWeight={'semibold'}>
        Create Goal
      </Text>
      <Box mt={'24px'}>
        <CreateGoalTabs
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          goalState={goalState}
          setGoalState={setGoalState}
        />
      </Box>
    </Flex>
  );
};

export default CreateGoals;
